import { render, staticRenderFns } from "./TransactionsReport.vue?vue&type=template&id=455cb2cc"
import script from "./TransactionsReport.vue?vue&type=script&lang=js"
export * from "./TransactionsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports